import { IList, IResponse } from '../response';
import { HomeworkType } from '../../enums';
import { LIVE_TYPE, COURSE_SESSION_LEARN_STATUS, COURSE_CHILD_TYPE, MEETING_STATUS } from '../../enums';
import { SwitchString, SwitchNum } from '../domainType';

export type ISessionList = IList<ISessionItem | IChapterItem>;
export type ICourseSessionList = IList<ISessionItem | IChapterItem>;
export type IChaptersLearnStatus = IResponse<{ [name: string]: { completion_status: 0 | 1 | 2 } }>;
export type ICollectionsResponse = IResponse<{ [name: string]: 0 | 1 }>;

export interface IResourceArrItem {
    resource_id: string;
    resource_type: number;
}

export interface ISessionSetup {
    advance?: number;
    allow_speak?: string;
    show_online_number?: string;
    live_clarity?: string;
    live_vendor?: string;
    mobile_direction?: string;
    screen_display_content?: string;
    start_ts?: string;
    live_type?: LIVE_TYPE;
    wx_share_title: string;
    wx_share_desc: string;
    show_online_count?: number;
    show_video?: number;
    show_audio?: number;
    type_name: string;
    ai_switch?: string;
    is_allow_download?: string;
    is_allow_anonymous?: string;
    is_completely_anonymous?: string;
    allow_view_timeline_comments?: string;
    allow_drag_track?: string;
    allow_student_upload?: string;
    homework_type?: HomeworkType;
    multi_eval_switch?: string;
    full_marks?: string;
    allow_student_score?: string;
    allow_interactivity?: string;
    allow_resubmit?: string;
    preview_comments?: string;
    /**
     * 发言列表默认排序方式，1 最热（默认），2 最新
     */
    comment_sort_type?: string;
    /**
     * 是否允许查看发言提交时间，1展示（默认），0不展示
     */
    is_comment_time_visible?: string;
}

export interface ISessionExtend {
    estimated_start_ts?: number;
    estimated_participate_num?: number;
    estimated_live_duration?: number;
    serverTime?: number;
    session_in_use: number;
    result_card_view: string;
    user_used: number;
    is_draft: number;
    lock: number;
    learn_status: COURSE_SESSION_LEARN_STATUS;
}

/**
 * 章节信息
 */
export interface IChapterItem {
    item_type: COURSE_CHILD_TYPE.CHAPTER;
    title: string;
    id: string;
    describe: string;
    lock: SwitchNum;
    session_count: number; // 章节下小节数
    status: SwitchString; // 是否对学员展示
    learn_status: number;
    chapter_progress: number;
    index: number;
}

/**
 * 小节状态
 */
export interface ISessionInfo {
    /**
     * 考试小节中题目来源可能为题库中随机，判断题目是否已经被删除，-> 是否有足够的的题目
     */
    have_enough_questions: 0 | 1;
}

declare type ISessionStatus = Record<number, ISessionInfo>;

/**
 * 小节信息
 */
export interface ISessionItem {
    item_type: COURSE_CHILD_TYPE.SESSION;
    element_id: number;
    eid: string;
    desc: string;
    access_permission: number;
    is_require: number;
    is_top: number;
    title: string;
    parent_id: number;
    parent_type: number;
    index: number;
    type: number;
    auto_check: number;
    create_time: number;
    setup: ISessionSetup;
    resource_arr: IResourceArrItem[];
    tags: string[];
    share_url: string;
    share_qrc: string;
    share_card_view: string;
    result_card_view: string;
    extend: ISessionExtend;
    stat: {
        participate_num: number | string;
        finish_num: number | string;
        like_num?: number | string;
        im_like_num?: number;
        average_duration?: string;
        average_score?: string;
        student_average_score?: string;
        full_marks?: string;
        question_num?: number;
        photo_num?: number;
        comment_num?: number;
        submit_cnt?: number; // 提交次数
    };
    /**
     * 考试小节中题目来源可能为题库中随机，判断题目是否已经被删除，-> 是否有足够的的题目
     */
    have_enough_questions: 0 | 1;
}

export interface IResourceMap {
    [props: string]: any;
}

export interface IListIsCollect {
    [props: number]: any;
}
export interface IResourceData {
    id: number;
    resource_id: string;
    file_name: string;
    file_duration: string;
    url: string;
    transcoding_url: string;
    thumb_info: string;
    status: string;
    is_recycle: number;
    is_deleted: number;
    is_live: number;
    live_session_status: string;
    create_time: number;
    resource_type: number;
    audio_weike: {
        audioDuration: number;
        audioUrl: string;
        imageUrl: string;
        imgArr: Array<{
            imageUrl: string;
        }>;
    };
}

export interface IMeetingResource {
    create_ts: string;
    duration: string;
    end_time: string;
    extend: string;
    id: string;
    join_url: string;
    meeting_id: string;
    resource_type: number;
    session_id: string;
    start_time: string;
    start_url: string;
    status: MEETING_STATUS;
    update_ts: string;
    zoom_uid: string;
}


export enum ECooperationRole {
    creator = 'creator',
    cooperator = 'cooperator',
    operator = 'operator',
    viewer = 'viewer',
}

export type TCooperationRole = keyof typeof ECooperationRole | '';

export interface ICooperationRole {
    is_cooperator: SwitchString;
    role_type: TCooperationRole;
    is_manager: boolean;
    manager_role_type?: '1' | '2';
}